"use strict";

import processInclude from "base/util";

import * as stores from "./storeLocator/storeLocator";

$(function () {
    processInclude(stores);
    stores.init();
});